import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import CustomerAddOrUpdate from "./MerchantCustomerAddOrUpdate";
import { showNotification, successNofication } from "src/shared/components/Notification";
import PndRestApi from "src/utils/pnd/PndRestApi";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { ERROR_MESSAGES } from "src/utils/pnd/PndConstants";

const HubCustomerAddNewAddress = ({ modalShow, setModalShow, isTitle, dataInfo }) => {
    const [isMapData, setMapData] = useState(null);
    const [mapInfo, setMapInfo] = useState(null);

    const toggle = () => setModalShow(prevState => !prevState);

    const handleSubmit = async (formValues) => {
        try {
            if (formValues["addressBookName"]?.label) {
                formValues["addressBookName"] = formValues["addressBookName"]["label"];
            }

            if (isMapData != null) formValues["address"] = isMapData;
            if (dataInfo?.address) formValues["address"] = dataInfo?.address;

            formValues["addressType"] = formValues["addressType"] ? 1 : 0;

            if (!formValues["address"]) {
                showNotification("theme-light", "ltr", "500", "Please fill in the address first.");
                return;
            }

            if (mapInfo) {
                const getVal = (code) => mapInfo.AddressElements.find(e => e.AddressElementTypeCode === code)?.Value;
                formValues["landMark"] = getVal(4);
                formValues["streetName"] = getVal(3);
                formValues["area"] = getVal(2);
                formValues["zoneName"] = getVal(7);
                formValues["city"] = getVal(8);
                formValues["emirates"] = getVal(1);
                formValues["latitude"] = getVal(10);
                formValues["longitude"] = getVal(9);
                formValues["grl"] = getVal(5);
            }

            formValues["status"] = formValues["status"] ? 1 : 0;

            const response = await PndRestApi.AddOrUpdateHubCustomer(formValues);
            if (response.status === 200 && response.data.status === 200) {
                successNofication("theme-light", "ltr", "200", ERROR_MESSAGES.successMessage);
                toggle();
            } else {
                showNotification("theme-light", "ltr", `${response.data.status}`, `Message:${response.data.message}`);
            }
        } catch (error) {
            showNotification("theme-light", "ltr", "500", ERROR_MESSAGES.tryCatchError);
        }
    };

    return (
        <Modal
            isOpen={modalShow}
            toggle={toggle}
            className="theme-light ltr-support credit-memo-modal-form-ani"
            centered
            style={{ maxWidth: '850px' }}
        >
            <div className="modal__header border-bottom-0 pb-0">
                <button
                    className="lnr lnr-cross modal__close-btn"
                    aria-label="modal__close-btn"
                    type="button"
                    onClick={toggle}
                />
                <div className="d-flex align-items-center mb-1">
                    <PersonAddIcon className="text-primary me-2" style={{ fontSize: '1.5rem' }} />
                    <h5 className="modal__title text-uppercase fw-bold m-0" style={{ color: "#21B368", fontSize: '1rem' }}>
                        {isTitle || "Add New Customer Address"}
                    </h5>
                </div>
            </div>
            <ModalBody className="p-0">
                <div className="p-3">
                    <CustomerAddOrUpdate
                        onSubmit={handleSubmit}
                        dataInfo={dataInfo}
                        setMapData={setMapData}
                        status={dataInfo?.status}
                        address={dataInfo?.address}
                        setMapInfo={setMapInfo}
                    />
                </div>
            </ModalBody>
        </Modal>
    );
};

export default connect()(HubCustomerAddNewAddress);
